<template>

  <div>
    <div class="d-flex justify-content-between align-items-center border-bottom">
      <ul
        class="nav nav-tabs">
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: tab === 'criteria' }"
            href="javascript:void(0)"
            @click="changeTab('criteria')">Buscar</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: tab === 'lastSearch' }"
            href="javascript:void(0)"
            @click="changeTab('lastSearch')">
            <div v-if="isRunning" class="spinner-border mr-1" style="width: 1rem; height: 1rem;"></div>
            Resultado
            </a>
        </li>
      </ul>
      <div class="pr-2">
        <a
          href="https://intercom.help/quickin/pt-BR/articles/14488845-seeker-hunting-inteligente-nativo-do-quickin"
          target="_blank"
          class="btn btn-sm btn-light">
          <i class="fas fa-question"></i>
        </a>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'JobSeekerHead',
  components: {
  },
  props: {
    isRunning: {
      type: Boolean,
      default: false
    },
    tab: {
      type: String,
      default: 'criteria'
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    changeTab (tab) {
      this.$emit('update:tab', tab)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobSeeker/JobSeekerHead.vue